import * as types from './types'

export default {
  async [types.NOTIFY_SUCCESS]({ commit, dispatch }, options) {
    await dispatch(types.HIDE_SNACKBAR)
    commit(types.SET_SNACKBAR_SUCCESS, options)
  },
  async [types.NOTIFY_ERROR]({ commit, dispatch }, options) {
    await dispatch(types.HIDE_SNACKBAR)
    commit(types.SET_SNACKBAR_ERROR, options)
  },
  async [types.NOTIFY_WARNING]({ commit, dispatch }, options) {
    await dispatch(types.HIDE_SNACKBAR)
    commit(types.SET_SNACKBAR_WARNING, options)
  },
  async [types.NOTIFY]({ commit, dispatch }, options) {
    await dispatch(types.HIDE_SNACKBAR)
    commit(types.SET_SNACKBAR, options)
  },
  [types.HIDE_SNACKBAR]({ commit }) {
    commit(types.SET_SNACKBAR_TO_HIDE)
  }
}
